/**
 * Optimized AmCharts 5 imports
 * Use these imports instead of importing entire modules
 * This enables better tree-shaking and code splitting
 */

// Core - only import what you need
export const importAmCharts5Core = () => import('./index');

// XY Charts (most common)
export const importAmCharts5XY = () => import('./xy');

// Percent charts (pie, donut, etc.)
export const importAmCharts5Percent = () => import('./percent');

// Radar charts
export const importAmCharts5Radar = () => import('./radar');

// Map charts
export const importAmCharts5Map = () => import('./map');

// Hierarchy charts (tree, sunburst, etc.)
export const importAmCharts5Hierarchy = () => import('./hierarchy');

// Flow charts (sankey, chord, etc.)
export const importAmCharts5Flow = () => import('./flow');

// Venn diagrams
export const importAmCharts5Venn = () => import('./venn');

// Word cloud
export const importAmCharts5WordCloud = () => import('./wc');

// Themes - Vite requires static imports, so we use a switch for common themes
export const importAmCharts5Theme = (themeName: string = 'Animated') => {
  switch (themeName) {
    case 'Animated':
      return import('./themes/Animated.js');
    case 'Dark':
      return import('./themes/Dark.js');
    case 'Dataviz':
      return import('./themes/Dataviz.js');
    case 'Frozen':
      return import('./themes/Frozen.js');
    case 'Kelly':
      return import('./themes/Kelly.js');
    case 'Material':
      return import('./themes/Material.js');
    case 'Micro':
      return import('./themes/Micro.js');
    case 'Moonrise':
      return import('./themes/Moonrise.js');
    case 'Responsive':
      return import('./themes/Responsive.js');
    case 'Spirited':
      return import('./themes/Spirited.js');
    default:
      return import('./themes/Animated.js');
  }
};

/**
 * Lazy load AmCharts 5 modules on demand
 * Usage:
 *   const am5 = await importAmCharts5Core();
 *   const am5xy = await importAmCharts5XY();
 */
export async function loadAmCharts5Modules(modules: string[] = ['core', 'xy']) {
  const loaded: any = {};
  
  for (const module of modules) {
    switch (module) {
      case 'core':
        loaded.core = await importAmCharts5Core();
        break;
      case 'xy':
        loaded.xy = await importAmCharts5XY();
        break;
      case 'percent':
        loaded.percent = await importAmCharts5Percent();
        break;
      case 'radar':
        loaded.radar = await importAmCharts5Radar();
        break;
      case 'map':
        loaded.map = await importAmCharts5Map();
        break;
      case 'hierarchy':
        loaded.hierarchy = await importAmCharts5Hierarchy();
        break;
      case 'flow':
        loaded.flow = await importAmCharts5Flow();
        break;
      case 'venn':
        loaded.venn = await importAmCharts5Venn();
        break;
      case 'wc':
        loaded.wc = await importAmCharts5WordCloud();
        break;
    }
  }
  
  return loaded;
}

